export default __webpack_public_path__ + "static/media/checkin.05454090.gif";